import { normalizeEquipmentRecord } from './equipmentDisplay';

const MAINTENANCE_SNAKE_TO_CAMEL = {
  equipment_id: 'equipmentId',
  scheduled_date: 'scheduledDate',
  completed_date: 'completedDate',
  technician_name: 'technicianName',
  serial_number: 'serialNumber',
  created_at: 'createdAt',
  updated_at: 'updatedAt',
};

export function normalizeMaintenanceRecord(raw = {}) {
  const out = { ...raw };
  for (const [snake, camel] of Object.entries(MAINTENANCE_SNAKE_TO_CAMEL)) {
    if (out[camel] == null && raw[snake] != null) out[camel] = raw[snake];
    if (out[snake] == null && raw[camel] != null) out[snake] = raw[camel];
  }
  return out;
}

export function normalizeReportPayload(data) {
  if (!data || typeof data !== 'object') return data;
  return {
    ...data,
    equipment: (data.equipment || []).map(normalizeEquipmentRecord),
    expiring: (data.expiring || []).map(normalizeEquipmentRecord),
    maintenance: (data.maintenance || []).map(normalizeMaintenanceRecord),
  };
}

/**
 * Reports store JSON in reports.file_url. Legacy rows may hold other strings.
 */
export function parseReportPayload(fileUrl) {
  if (fileUrl == null || fileUrl === '') {
    throw new Error('Données du rapport manquantes');
  }
  if (typeof fileUrl === 'object') {
    return normalizeReportPayload(fileUrl);
  }
  const trimmed = String(fileUrl).trim();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    return normalizeReportPayload(JSON.parse(trimmed));
  }
  throw new Error('Format de rapport obsolète — régénérez le rapport');
}
